export default __webpack_public_path__ + "41386d2a4d4e1363c390452aa40c0684.png";